<template>
  <section class="ugc-history control">
    <div class="ugc-history-wrapper text-center">
      <button
        class="ugc-history-wrapper-undo"
        @click="undo"
        :disabled="isUndoDisabled"
      >
        <div class="text-icon">{{ translations.ugcHistoryUndo }}</div>
        <customs-svg-icon
          v-if="$store.state.utils.configuration.enableNewUgcModal"
          :src="`${ customsAssets }/svg/customizer/icon-undo.svg`"
        ></customs-svg-icon>
        <span
          v-else
          class="icon icon-undo"
        ></span>
      </button>
      <button
        class="ugc-history-wrapper-redo"
        @click="redo"
        :disabled="isRedoDisabled"
      >
        <div class="text-icon">{{ translations.ugcHistoryRedo }}</div>
        <customs-svg-icon
          v-if="$store.state.utils.configuration.enableNewUgcModal"
          :src="`${ customsAssets }/svg/customizer/icon-redo.svg`"
        ></customs-svg-icon>
        <span
          v-else
          class="icon icon-redo"
        ></span>
      </button>
    </div>
    <div class="ugc-history-instructions text-center">
      {{ translations.ugcHistoryInstructions }}
    </div>
  </section>
</template>
<script>
import customsSvgIcon from '@/components/Globals/SvgIcon';

export default {
  name: "UgcToolsHistory",
  components: {
    customsSvgIcon,
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    isUndoDisabled() {
      return (
        !this.$store.getters["ugc/stateManager/undos"].length ||
        this.$store.state.ugc.stateManager.isLoading
      );
    },
    isRedoDisabled() {
      return (
        !this.$store.getters["ugc/stateManager/redos"].length ||
        this.$store.state.ugc.stateManager.isLoading
      );
    },
    customsAssets() {
      return this.$store.state.endPoints.customizer.customsAssets;
    },
  },
  methods: {
    undo() {
      if (this.isUndoDisabled) return;
      const { background_color } = this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex];
      const bgColor = this.$store.getters["ugc/stateManager/undos"].filter(
        ({ control }) => control === "background-color"
      );
      if (background_color && bgColor && bgColor.length) {
        this.$store.commit("ugc/tempData/SET_BACKGROUND");
      }
      this.$store.dispatch("ugc/stateManager/PREV_STEP").then(() => {
        const tileOrPopArt = this.$store.getters["ugc/stateManager/undos"].filter(
          ({ control }) => control === "tile" || control === "pop-art"
        );
        return this.$store.commit("ugc/stateManager/APPLY_TILE_OR_POPART", tileOrPopArt.length > 0);
      }).then(() => {
        this.$eventBus.$emit("reload-placement-guide");
      });
    },
    redo() {
      if (this.isRedoDisabled) return;
      const { background_color } = this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex];
      const bgColor = this.$store.getters["ugc/stateManager/redos"].filter(
        ({ control }) => control === "background-color"
      );
      if (!background_color && bgColor && bgColor.length) {
        this.$store.commit("ugc/tempData/SET_BACKGROUND", bgColor[bgColor.length-1].data.background);
      }
      this.$store.dispatch("ugc/stateManager/NEXT_STEP").then(() => {
        const tileOrPopArt = this.$store.getters["ugc/stateManager/undos"].filter(
          ({ control }) => control === "tile" || control === "pop-art"
        );
        return this.$store.commit("ugc/stateManager/APPLY_TILE_OR_POPART", tileOrPopArt.length > 0);
      }).then(() => {
        this.$eventBus.$emit("reload-placement-guide");
      });
    }
  },
};
</script>
